var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-snackbar',{attrs:{"value":_vm.getError,"timeout":3500,"absolute":"","top":"","right":"","color":"error","outlined":""},scopedSlots:_vm._u([{key:"action",fn:function(ref){
var attrs = ref.attrs;
return [_c('v-btn',_vm._b({attrs:{"color":"error","text":""},on:{"click":_vm.clearError}},'v-btn',attrs,false),[_c('v-icon',[_vm._v("mdi-close")])],1)]}}])},[_vm._v(" "+_vm._s(_vm.getError)+" ")])}
var staticRenderFns = []

export { render, staticRenderFns }